import { Component, OnInit } from '@angular/core';
import { StorageService } from './services/storage.service';
@Component({
  selector: 'app-layout',
  standalone: false,
  template: `
    <app-prelogin *ngIf="!loggedIn"></app-prelogin>
    <router-outlet></router-outlet>
  `,
  styles: [``]
})
export class LayoutComponent implements OnInit {
  constructor(private storageService: StorageService) { }
  loggedIn = false;

  ngOnInit() {
    this.storageService.loggedIn$.subscribe((value) => {
      this.loggedIn = value;
    });
  }
}
